import { whatsappValidationEnabled } from '@/consts/auth';

const VALIDATION_KEYS = ['email', 'whatsapp'];

const includesMissing = (missing, key) => {
  if (!Array.isArray(missing)) return false;
  return missing.includes(key);
};

export const getMissingValidationsFromDetail = (detail) => {
  if (typeof detail !== 'string') return null;

  const normalizedDetail = detail.toLowerCase();
  if (!normalizedDetail.includes('valid') || !normalizedDetail.includes('necess')) return null;

  const [, rawMissing] = detail.match(/\[([^\]]+)\]/) || [];
  if (!rawMissing) return null;

  const missing = rawMissing
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter((item) => VALIDATION_KEYS.includes(item));

  return missing.length ? missing : null;
};

const isEmailPending = (user, missing) => {
  if (includesMissing(missing, 'email')) return true;
  if (!user) return false;
  return user.emailValidated === false;
};

const isWhatsappPending = (user, missing) => {
  if (includesMissing(missing, 'whatsapp')) return true;
  if (!user) return false;
  if (!whatsappValidationEnabled) return false;
  if (!user.is_producer) return false;
  return user.whatsappValidated === false;
};

export const getVerificationStatus = (user, missing, options = {}) => {
  const { includeWhatsapp = true } = options;
  const emailPending = isEmailPending(user, missing);
  const whatsappPending = includeWhatsapp ? isWhatsappPending(user, missing) : false;

  return {
    isToValidateEmail: emailPending,
    isToValidateWhatsapp: whatsappPending,
    isVerificationPending: emailPending || whatsappPending,
  };
};

export const hasPendingVerification = (user, missing, options) =>
  getVerificationStatus(user, missing, options).isVerificationPending;
